import React, { useEffect, useState } from "react";
import DevicesTable from "./components/DevicesTable";
import Edit from "./modals/Edit";
import View from "./modals/View";
import Logs from "./modals/Logs";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Divider from "@material-ui/core/Divider/index";
import axios from "axios";
import { updateObject } from "../../../helpers/updateObject";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import Filter from "./modals/Filter";
import { toast, ToastContainer } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';

const appointmentData = [
  { id: "ACCESS_CONTROL", name: "Access control" },
  { id: "TIME_CONTROL", name: "Time control" },
  { id: "ENROLL", name: "Enroll" },
]

function Devices(props) {
  const [disabledRestart, setDisabledRestart] = useState(false)
  const [disabledSYNC, setDisabledSYNC] = useState(false)
  const [disabledSYNCCard, setDisabledSYNCCard] = useState(false)
  const [disabledSYNCFinger, setDisabledSYNCFinger] = useState(false)
  const [disabledSYNCFace, setDisabledSYNCFace] = useState(false)
  const [disabledLog, setDisabledLog] = useState(false)
  const [devices, setDevices] = useState([]);
  const [chooseDeviceId, setChooseDeviceId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteDevicesIds, setDeleteDevicesIds] = useState([]);
  const [showLogs, setShowLogs] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [showFilter, setShowFilter] = React.useState(false);
  const [filterInputs, setFilterInputs] = useState({
    name: "",
    appointment: "",
    deviceModelId: "",
    devicePlaceId: "",
    deviceTypeId: "",
    direction: "",
    ipAddress: "",
    status: ""

  });
  const toggleDrawer = (open) => (event) => {
    setShowView(open);
  };
  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onDevices = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
      appointment,
      name,
      deviceModelId,
      devicePlaceId,
      deviceTypeId,
      direction,
      ipAddress,
      status

    } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}device?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${name ? `&name=${name}` : ""}${appointment ? `&appointment=${appointment}` : ""}${deviceModelId ? `&deviceModelId=${deviceModelId}` : ""}${devicePlaceId ? `&devicePlaceId=${devicePlaceId}` : ""}${deviceTypeId ? `&deviceTypeId=${deviceTypeId}` : ""}${direction ? `&direction=${direction}` : ""}${ipAddress ? `&ipAddress=${ipAddress}` : ""}${status ? `&status=${status}` : ""}`)
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
        setDevices(content);
        setIsError(false);
        setCount(totalElements)

      })
      .catch(() => {
        setIsLoading(false);
        setDevices([]);
        setIsError(true);
      });
  };

  const onDeviceLogs = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}device/log/json?${id ? `id=${id}` : ""}`);
  };
  
  const onDeviceChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}device/${id}`);
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      onDevices(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);



  const [devicePlaceId, setDevicePlaceId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}devicePlace/select`)
      .then(({ data }) => {
        const models = data.map(({ id, name }) => ({
          value: id,
          label: name,
        }))
        setDevicePlaceId(models);
      });
  }, []);
  const [deviceTypeId, setDeviceTypeId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}deviceType`)
      .then(({ data: { content } }) => {
        const deviceTypeId = content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDeviceTypeId(deviceTypeId);
      });
  }, []);

  const [deviceModelId, setDeviceModelId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}deviceModel`)
      .then(({ data: { content } }) => {
        const deviceModelId = content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDeviceModelId(deviceModelId);
      });
  }, []);

  const [appointmentSelect, setAppointmentSelect] = useState();

  useEffect(() => {
    const appointment = appointmentData.map(({ id, name }) => ({
      value: id,
      label: name,
    }))
    setAppointmentSelect(appointment)

  }, []);

  const success = (text = "") => {
    toast.success(text, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  const error = (text = "") => {
    toast.error(text, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  const onRestartStatus = (id) => {
    setDisabledRestart(true)

    axios
      .post(
        `${process.env.REACT_APP_API_URL}device/restart/${id}`,
      )
      .then(() => {
        onDevices(orderBy, sortField, skip, take);
        setDisabledRestart(false)
        success('Restart uğurludur')

      });

  };




  const onSYNCStatus = (id) => {
    setDisabledSYNC(true)
    axios
      .post(
        `${process.env.REACT_APP_API_URL}device/sync/${id}`,
      )
      .then(() => {
        onDevices(orderBy, sortField, skip, take);
        success('SYNC uğurludur')
        setDisabledSYNC(false)

      });
  };

  const onSYNCCardStatus = (id) => {
    setDisabledSYNCCard(true)

    axios
      .post(
        `${process.env.REACT_APP_API_URL}device/sync/card/${id}`,
      )
      .then(() => {
        onDevices(orderBy, sortField, skip, take);
        success('Kart sinxronu uğurludur')
        setDisabledSYNCCard(false)
      });
  };

  const onSYNCFingerStatus = (id) => {
    setDisabledSYNCFinger(true)

    axios
      .post(
        `${process.env.REACT_APP_API_URL}device/sync/finger/${id}`,
      )
      .then((res) => {
        onDevices(orderBy, sortField, skip, take);
        setDisabledSYNCFinger(false)
        res.data
        ?
        success('Barmaq izi sinxronu uğurludur')
        :
        error('Barmaq izi sinxronu uğursuzdur')
      });
  };
  const onSYNCFaceStatus = (id) => {
    setDisabledSYNCFace(true)

    axios
      .post(
        `${process.env.REACT_APP_API_URL}device/sync/face/${id}`,
      )
      .then((res) => {
        onDevices(orderBy, sortField, skip, take);
        setDisabledSYNCFace(false)
        res.data
        ?
        success('Üz təsviri sinxronu uğurludur')
        :
        error('Üz təsviri sinxronu uğursuzdur')
      });
  };

  const onUpdateLog = (id) => {
    setDisabledLog(true)
    axios
      .post(
        `${process.env.REACT_APP_API_URL}device/log/?${id ? `id=${id}` : ""}`,
      )
      .then((res) => {
        res.data
          ?
          success('Loqlar  ugurla yeniləndi')
          :
          error('Loqlar  ugurla yenilənmədi')
        onDevices(orderBy, sortField, skip, take);
        setDisabledLog(false)

      });
  };

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Qurğular</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <DevicesTable
        devices={devices}
        isLoading={isLoading}
        isError={isError}
        setChooseDeviceId={setChooseDeviceId}
        setOpenView={toggleDrawer(true)}
        setShowCreate={setShowCreate}
        setShowRemove={setShowRemove}
        setShowEdit={setShowEdit}
        setShowLogs={setShowLogs}
        setDeleteDevicesIds={setDeleteDevicesIds}
        deleteDevicesIds={deleteDevicesIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        onRestartStatus={onRestartStatus}
        onSYNCStatus={onSYNCStatus}
        onSYNCСardStatus={onSYNCCardStatus}
        onSYNCFingerStatus={onSYNCFingerStatus}
        onUpdateLog={onUpdateLog}
        onSYNCFaceStatus={onSYNCFaceStatus}
        disabledSYNCCard={disabledSYNCCard}
        disabledSYNCFinger={disabledSYNCFinger}
        disabledSYNCFace={disabledSYNCFace}
        disabledLog={disabledLog}
        disabledRestart={disabledRestart}
        disabledSYNC={disabledSYNC}

        
      />
      {showCreate && (
        <Create
          show={showCreate}
          onHide={setShowCreate}
          onDevices={onDevices}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
          devicePlaceId={devicePlaceId}
          deviceModelId={deviceModelId}
          deviceTypeId={deviceTypeId}
          appointmentSelect={appointmentSelect}
        />
      )}

      {showView && (
        <View
          open={showView}
          onClose={toggleDrawer(false)}
          onDeviceChoose={onDeviceChoose}
          chooseDeviceId={chooseDeviceId}
        />
      )}

      {showRemove && (
        <Delete
          id={chooseDeviceId}
          show={showRemove}
          onHide={setShowRemove}
          onDevices={onDevices}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
        />
      )}

      {showLogs && (
        <Logs
          onDeviceLogs={onDeviceLogs}
          chooseDeviceId={chooseDeviceId}
          show={showLogs}
          onHide={setShowLogs}
        />
      )}

      {showEdit && (
        <Edit
          show={showEdit}
          onHide={setShowEdit}
          onDevices={onDevices}
          id={chooseDeviceId}
          onDeviceChoose={onDeviceChoose}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
          devicePlaceId={devicePlaceId}
          deviceModelId={deviceModelId}
          deviceTypeId={deviceTypeId}
          appointment={appointmentSelect}
        />
      )}

      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        devicePlaceId={devicePlaceId}
        deviceModelId={deviceModelId}
        deviceTypeId={deviceTypeId}
        appointmentSelect={appointmentSelect}

      />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default Devices;
